import { BaseCardWrapper, IconButton, twClassMerge  } from '@healthhub/react-ui';
import { Typography } from 'antd';
import type { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router';

import { OutlinedRefreshIcon } from '@shared/assets-icon';
import { Button } from '@shared/components';


const { Title } = Typography;

interface PostLoginDashboardCardProps {
  button: {
    title: string;
  };
  className?: string;
  image: string;
  isLoading?: boolean;
  isShowRefreshButton?: boolean;
  onRefreshClick?: () => void;
  title: string;
  url: string;
}

const PostLoginDashboardCard = ({
  button,
  children,
  className,
  image,
  isLoading,
  isShowRefreshButton,
  onRefreshClick,
  title,
  url,
}: PropsWithChildren<PostLoginDashboardCardProps>) => {
  const navigate = useNavigate();

  return (
    <BaseCardWrapper
      className={twClassMerge(
        'relative flex min-h-56 flex-col justify-between gap-4 border border-secondary-green-100 p-6 shadow-[0px_4px_20px_0px_rgba(0,0,0,0.08)]',
        className
      )}
    >
      <div className="flex flex-col gap-4">
        <div className="flex justify-between">
          <Title className="m-0 text-xl text-primary-blue-grey" level={5}>
            {title}
          </Title>
          {!!isShowRefreshButton && (
            <IconButton
              aria-label="Refresh appointment"
              className={twClassMerge('disabled:bg-transparent', { 'animate-spin ': isLoading })}
              data-testid="refresh-button"
              disabled={isLoading}
              icon={<OutlinedRefreshIcon className="size-6 [&_path]:stroke-primary-green-4" />}
              onClick={onRefreshClick}
            />
          )}
        </div>
        {children}
      </div>
      <img alt="" className="absolute bottom-0 right-0 hidden lg:block" data-testid="image" src={image} />
      <Button
        className="h-10 w-full self-start whitespace-break-spaces bg-primary-blue-grey-3 py-0 language-ta:w-80 md:w-60"
        onClick={() => navigate(url)}
      >
        {button.title}
      </Button>
    </BaseCardWrapper>
  );
};

export default PostLoginDashboardCard;
